import { useAuth } from '@clerk/clerk-react'
import { useMutation } from '@tanstack/react-query'
import { askLupe } from '@/lib/api/lupe'
import type { LupeReply } from '@/lib/types/universe'

/** Sends a chat turn to Lupe. The thread renders its own error, so the global toast is suppressed. */
export function useAskLupe() {
  const { getToken } = useAuth()
  return useMutation<
    LupeReply,
    Error,
    { message: string; history: { role: 'user' | 'assistant'; text: string }[] }
  >({
    mutationFn: async (body) => askLupe((await getToken()) ?? '', body),
    meta: { suppressErrorToast: true },
  })
}
